
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqJHlgNsw0TM71_l5i_45vbFZu4QR2peSbDR7RReudgcQ6kMeta } from "/vercel/path0/layers/modules/fubex-pages/pages/faq.vue?macro=true";
import { default as kybdbUENIiefjd3lSLUbH5WQnR1TFvI36BCJUBhp6r3sSEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/kyb.vue?macro=true";
import { default as blogbslzrmi9D7UX8gfzv3v0U_45qj81QsaYaGrg_KCsZQ2o0Meta } from "/vercel/path0/layers/modules/fubex-blog/pages/blog.vue?macro=true";
import { default as indexFZFzcGFb8dXy_35cSAys2HZtxJqR2jJGI_wIBEvonigMeta } from "/vercel/path0/apps/taurex/pages/index.vue?macro=true";
import { default as loginMN6itfFQv8pEtWsPy0hY_qHsa9zPmj3LJZC7vhEmF8MMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/login.vue?macro=true";
import { default as o_45nasX4DVHEjNzjUW91NxcF3SUiVBqRB0xi4C352GbLYhLGkMeta } from "/vercel/path0/layers/modules/fubex-pages/pages/o-nas.vue?macro=true";
import { default as logoutsr38LBI7aWyO_45cmy96Y72WC_45WYvjRsL_XBVrDQDnUwoMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/logout.vue?macro=true";
import { default as kontaktxfx_455AV80yg_45dE3y0PZJWnEF935H0Vu6lz_45w_80bfLkMeta } from "/vercel/path0/layers/modules/fubex-pages/pages/kontakt.vue?macro=true";
import { default as kyb_45vRyiSl_45KMcSG_45IPdLRN1KkiDKuemsAHBOqDIrsicxUMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/kyb.vue?macro=true";
import { default as indexKZBzrG4ojB0XH78RdIfoFdmm7LC_459w7XVjPU_G4uRiEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/index.vue?macro=true";
import { default as chargesD_45P__45HOpxnApj7M2O3J_AcWJTaYjQCn8LkueI1ZQx_45kMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/charges.vue?macro=true";
import { default as _91id_93K4XxfwP6fTaFvploSmC0kxVRPk7_45gjePM23E36WnIK8Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/[id].vue?macro=true";
import { default as overlimitydT8dSfbty2kFXpAWdu9wTqEgNGXSue0m115dg6Oyh0Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/overlimit.vue?macro=true";
import { default as indexB8Jvoj6Imu5nOPKfHtYjrjjaSpkDlNtfjMRbBL0q_2oMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/index.vue?macro=true";
import { default as statisticsWBJRPlr5N0Zhep7_45zMZ5IcWTYLG8uWxPsKWXAwAQ_fYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/statistics.vue?macro=true";
import { default as _91id_93C6qtoWHZM4QH4j294jYCnQmAEKDazp0NKUqkmPVaklQMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/[id].vue?macro=true";
import { default as _91id_93dUIGLBFzrZ2lteuKTqXHO4fVi3w_45CN2ymZ8oGIO9wQMMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/[id].vue?macro=true";
import { default as indexZx7QkcKYTK7wiZtSXjzVUT2D5PazBHY4n3VLL4OqYooMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/index.vue?macro=true";
import { default as indexkknAEM0qgrFPfuWGaab0RGZmc7CrpzTUJByrtOhIfOsMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/index.vue?macro=true";
import { default as transactionsWMP1EBawRQvIn7cydd3zQyzdGpKYTfQuhs8Z4JshrScMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/transactions.vue?macro=true";
import { default as bank_45accountsV_t00L6RKzXmaC5MeMZ2YJ4YL4eiEoN4GD33AlMa31EMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank-accounts.vue?macro=true";
import { default as _91id_93J5w0p5mG1Sqg0ouMn_45EeFkKw_oSgkgmdPjYvkcqWemMMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/[id].vue?macro=true";
import { default as indexz_45NHhQb6aLecfEj1BFpwndtsn6WqsPwGKeVS7uYpSRkMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/index.vue?macro=true";
import { default as _91id_93g4SANzRBe5k0oLiBFweojezt3ZjyGQEJRn4cbNSw8dAMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/branches/[id].vue?macro=true";
import { default as adminxoHPY1PNPC2SrOstzov4KuUO0rHm3forLL7uUhzXT3wMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/admin.vue?macro=true";
import { default as indexqQ3On7t0j_K41jrND2jHwLd_453iiqSbTwQY6FFTb4hykMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/index.vue?macro=true";
import { default as rewardsneyU4fN2yOX21aAi4v9nRzw9hd4EAW_hicQKDphu6tYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/rewards.vue?macro=true";
import { default as withdrawalsvzhRF5_TrpObOR7FGLvQl4rII5LVgopbZweMFgasSDAMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/withdrawals.vue?macro=true";
import { default as bonusOKcKNC56_45D_g6FmJ2K2lgPaQG1kKiCrmfsHwHy5evcEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus.vue?macro=true";
import { default as index04QJKf6T_45pNhb1dk3drwGhxyk0ZiTvEkztK9zY2wD4cMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/index.vue?macro=true";
import { default as indexOeSBnmlF4_zL_45djLTwK54FzCSy0y5xuealqDTPpACjUMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/index.vue?macro=true";
import { default as verifyud5q51uIAhkYwS7FmgSTU7vQOod62tg5F15KSOMbyzsMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/verify.vue?macro=true";
import { default as bank_45accountsAZl2THTmevaOBIf3VapB4S2qppht59W6UiJi7fNl2n4Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/bank-accounts.vue?macro=true";
import { default as change_45passwordK_45YeIH9wNBBLhbZSt_JJq18_45YxkgInjoDac_hpzgJZYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account/change-password.vue?macro=true";
import { default as accountsTTytLKaKHdC0AHbbI9do_45kq6jImCmf42AkX_tAlnugMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/account.vue?macro=true";
import { default as historynOrk9G0HmsCvcS4aQfUHERVIFShDOKUxb3hG0rM50t4Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/history.vue?macro=true";
import { default as exchangeJjgabHmY7sDnSgSov0lv_45oW_cRtmFdskQPhP0wImZWEMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/exchange.vue?macro=true";
import { default as overviewVjF0WUFqDYFQX8XPOdZ0CNSiTMm08G6Reg3yhtTWXZ4Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/overview.vue?macro=true";
import { default as indexxNkk8nVqaRN6O2NzagEE9PohaU9_45_rVU025NkigcZfoMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/index.vue?macro=true";
import { default as usersYtGW9j7onaeeAihssNsVEHs_45qClKmN7XYbTlBy_45d1NYMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/users.vue?macro=true";
import { default as ordersT85M8QpTXvc7g7_tdSVnxIVCy_3DnDme5WA1Oh_451Z04Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/orders.vue?macro=true";
import { default as chargesekvxRCXRytUvpDQWivPata_45o53MwXUiNh8ii0eT87OoMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/charges.vue?macro=true";
import { default as transactionsH8URdmr5pbJuv3tFqs27mfBsIRgyXOUMLqxzKqwgEUgMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/transactions.vue?macro=true";
import { default as inspectorW9wug0sHb1nKcCmEpQl_45McfcnozAYU_vl5LuNjtIks0Meta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector.vue?macro=true";
import { default as _91id_932_452x3EtgWZQPXiluz_454AyoMonEJ8FPLh9dN_45NjBbrXcMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/orders/[id].vue?macro=true";
import { default as verify_45resultzbxCjqVIiNfJ1h8vWqRjHKxjHsUfL6ucPlVIQl48M9MMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile/verify-result.vue?macro=true";
import { default as profileo_k2RMPPMdX_AgxXCeROglqbszRmvIGYk_1yMy3_45YwQMeta } from "/vercel/path0/layers/modules/fubex-profile/pages/profile.vue?macro=true";
import { default as affiliateuFIsZMWv4k7YtRIplNNX6SmOGip6KThQeF_458rQiFdW8Meta } from "/vercel/path0/apps/taurex/pages/affiliate.vue?macro=true";
import { default as email_45verifiedwieJmRnUCdruWrnrEoR8AmAqTrzcqPGZsfDgNsROWp0Meta } from "/vercel/path0/layers/modules/fubex-auth/pages/email-verified.vue?macro=true";
import { default as o_45kryptomenachVVRSvAcM2Imh7jzZ_isey14MhI8lSo_45aEeEsWoOhOOoMeta } from "/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach.vue?macro=true";
import { default as signup_45success_45wQ_ysq4nYMMCotjupnHU8k6gSDlucyCJQnJdBdod1EMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/signup-success.vue?macro=true";
import { default as _91userId_93pSRVmUJMrepxiyVJLHF2_45lW6SkACnfTownOum_45WzXC4Meta } from "/vercel/path0/layers/modules/fubex-auth/pages/invite/[userId].vue?macro=true";
import { default as kurzovni_45listekO_8Uf_JK45Vxg5KHcKWOkH3Q6E8Cz0hNrc5_va_JziAMeta } from "/vercel/path0/apps/taurex/pages/kurzovni-listek.vue?macro=true";
import { default as smena_45kryptomenEgDpKd11aaJyalJVleac1CX5yowV_UqaiDIYY_45bve0kMeta } from "/vercel/path0/apps/taurex/pages/smena-kryptomen.vue?macro=true";
import { default as icon4wDNVHdMRNEdOB26hscBVGEpm9693IN03kVndQlh0c8Meta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/icon.vue?macro=true";
import { default as update_45passwordPB2r4tb93DtNSimYEbJ1mL7mlVTakVPo8UvZb9uIItgMeta } from "/vercel/path0/layers/modules/fubex-auth/pages/update-password.vue?macro=true";
import { default as _91slug_93CoBOq_mHh0IxlG7tW48oFxa_nIJXT6IcYeHePT_45wjfIMeta } from "/vercel/path0/layers/modules/fubex-blog/pages/blog-post/[slug].vue?macro=true";
import { default as alert_454lrse8Ia3Ln61_iorkksdY02lx_0zrdqNTwSAJupXIMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/alert.vue?macro=true";
import { default as badge5EL6k92Cif_qQc_Jy_45rCsezpBKCx2cY5i7UDdSvZ8PsMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/badge.vue?macro=true";
import { default as indexrbqaRebwOjzXEjrZTZuFNEjJ6auEVC_459pRHtkam_j_45gMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/index.vue?macro=true";
import { default as inputZkPKN06zE_oiLXTFxKDynHsIEdqhxyZaywSEjspc160Meta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/input.vue?macro=true";
import { default as labelxcmbUV5kc1Gl5P_m5kGccVBj1DOG4pvSrr7N0xkKEbkMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/label.vue?macro=true";
import { default as radios0RZurvXBTwruVg87NXH4zwnRsT_QCvWxOVeohQT7WQMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/radio.vue?macro=true";
import { default as button6fhFptj0GopBU_ANRZNH4n6dmkC3jt5a_I2Mr89W00oMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/button.vue?macro=true";
import { default as dialogKDlk6ny7vVDV8WfbC2TUbCKw4fDnN4yqut4ByXXvpu0Meta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/dialog.vue?macro=true";
import { default as select1Oe6Jl9XNUFmMjw2QK_45wsbO8ERWbYem1OFaiRwPBkfsMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/select.vue?macro=true";
import { default as shadowsLL0cOl7sOHopUzv0nIBnf_1D4JAOqlimMt9DTDoqa6EMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/shadows.vue?macro=true";
import { default as checkboxCJFhm279AsDLHsxOrcWsvQteXJBPiitScuzFuVJC71sMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/checkbox.vue?macro=true";
import { default as smenarensky_45softwarektn0nks1zbTQhsh0DtuJEqvK5CRZRhyv_45y6HmAS9EXoMeta } from "/vercel/path0/layers/modules/fubex-pages/pages/smenarensky-software.vue?macro=true";
import { default as file_45inputimS_45MVKkqiCOqNfjupPWuIvx8KudLPJA6IfRHOSwjMYMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/file-input.vue?macro=true";
import { default as indexfWwXar2l2YG_45fvJBpYPbT_MuuvIXY74BCYQ_wtLP_vcMeta } from "/vercel/path0/layers/components/fubex-components/pages/styleguide/theme/index.vue?macro=true";
import { default as nakup_45kryptomen_45na_45firmuHRMXayqyKDF7uh2RFST1DStLIv4Qwb3HopwgzIr3X8sMeta } from "/vercel/path0/layers/modules/fubex-pages/pages/nakup-kryptomen-na-firmu.vue?macro=true";
import { default as _91slug_93IKcYr1jjpGmJCx_nZ3OSTuk2UPPHiGY_zyBNihSerBcMeta } from "/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach-post/[slug].vue?macro=true";
import { default as platba_45faktur_45kryptomenamiCYuNG4WZNPJ2IlYcrsgNFhJyCHShTKXPv7vq7CAOJX0Meta } from "/vercel/path0/layers/modules/fubex-pages/pages/platba-faktur-kryptomenami.vue?macro=true";
import { default as component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDkMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.3_@upstash+redis@1.34.8_@vercel+kv@3.0.0__nn4jabo3477h27fpp7i6cczm6e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDk } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.3_@upstash+redis@1.34.8_@vercel+kv@3.0.0__nn4jabo3477h27fpp7i6cczm6e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/faq.vue")
  },
  {
    name: "kyb",
    path: "/kyb",
    meta: kybdbUENIiefjd3lSLUbH5WQnR1TFvI36BCJUBhp6r3sSEMeta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/kyb.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/blog.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/apps/taurex/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/login.vue")
  },
  {
    name: "o-nas",
    path: "/o-nas",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/o-nas.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/logout.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/kontakt.vue")
  },
  {
    name: "profile-parent",
    path: "/profile",
    meta: { ...(profileo_k2RMPPMdX_AgxXCeROglqbszRmvIGYk_1yMy3_45YwQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile.vue"),
    children: [
  {
    name: adminxoHPY1PNPC2SrOstzov4KuUO0rHm3forLL7uUhzXT3wMeta?.name,
    path: "admin",
    meta: {"middleware":"admin"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin.vue"),
    children: [
  {
    name: "profile-admin-kyb",
    path: "kyb",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/kyb.vue")
  },
  {
    name: "profile-admin",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/index.vue")
  },
  {
    name: "profile-admin-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/charges.vue")
  },
  {
    name: "profile-admin-bank-id",
    path: "bank/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/[id].vue")
  },
  {
    name: "profile-admin-overlimit",
    path: "overlimit",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/overlimit.vue")
  },
  {
    name: "profile-admin-bank",
    path: "bank",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank/index.vue")
  },
  {
    name: "profile-admin-statistics",
    path: "statistics",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/statistics.vue")
  },
  {
    name: "profile-admin-users-id",
    path: "users/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/[id].vue")
  },
  {
    name: "profile-admin-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/[id].vue")
  },
  {
    name: "profile-admin-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/users/index.vue")
  },
  {
    name: "profile-admin-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/orders/index.vue")
  },
  {
    name: "profile-admin-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/transactions.vue")
  },
  {
    name: "profile-admin-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/bank-accounts.vue")
  },
  {
    name: "profile-admin-exchange-office-id",
    path: "exchange-office/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/[id].vue")
  },
  {
    name: "profile-admin-exchange-office",
    path: "exchange-office",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/index.vue")
  },
  {
    name: "profile-admin-exchange-office-branches-id",
    path: "exchange-office/branches/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/admin/exchange-office/branches/[id].vue")
  }
]
  },
  {
    name: "bonus",
    path: "bonus",
    meta: bonusOKcKNC56_45D_g6FmJ2K2lgPaQG1kKiCrmfsHwHy5evcEMeta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus.vue"),
    children: [
  {
    name: "profile-bonus",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/index.vue")
  },
  {
    name: "profile-bonus-rewards",
    path: "rewards",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/rewards.vue")
  },
  {
    name: "profile-bonus-withdrawals",
    path: "withdrawals",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/bonus/withdrawals.vue")
  }
]
  },
  {
    name: "profile",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/index.vue")
  },
  {
    name: "account",
    path: "account",
    meta: accountsTTytLKaKHdC0AHbbI9do_45kq6jImCmf42AkX_tAlnugMeta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account.vue"),
    children: [
  {
    name: "profile-account",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/index.vue")
  },
  {
    name: "profile-account-verify",
    path: "verify",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/verify.vue")
  },
  {
    name: "profile-account-bank-accounts",
    path: "bank-accounts",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/bank-accounts.vue")
  },
  {
    name: "profile-account-change-password",
    path: "change-password",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/account/change-password.vue")
  }
]
  },
  {
    name: "history",
    path: "history",
    meta: historynOrk9G0HmsCvcS4aQfUHERVIFShDOKUxb3hG0rM50t4Meta || {},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/history.vue")
  },
  {
    name: "profile-exchange",
    path: "exchange",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/exchange.vue")
  },
  {
    name: "profile-overview",
    path: "overview",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/overview.vue")
  },
  {
    name: inspectorW9wug0sHb1nKcCmEpQl_45McfcnozAYU_vl5LuNjtIks0Meta?.name,
    path: "inspector",
    meta: {"middleware":"inspector"},
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector.vue"),
    children: [
  {
    name: "profile-inspector",
    path: "",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/index.vue")
  },
  {
    name: "profile-inspector-users",
    path: "users",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/users.vue")
  },
  {
    name: "profile-inspector-orders",
    path: "orders",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/orders.vue")
  },
  {
    name: "profile-inspector-charges",
    path: "charges",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/charges.vue")
  },
  {
    name: "profile-inspector-transactions",
    path: "transactions",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/inspector/transactions.vue")
  }
]
  },
  {
    name: "profile-orders-id",
    path: "orders/:id()",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/orders/[id].vue")
  },
  {
    name: "profile-verify-result",
    path: "verify-result",
    component: () => import("/vercel/path0/layers/modules/fubex-profile/pages/profile/verify-result.vue")
  }
]
  },
  {
    name: "affiliate",
    path: "/affiliate",
    component: () => import("/vercel/path0/apps/taurex/pages/affiliate.vue")
  },
  {
    name: "email-verified",
    path: "/email-verified",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/email-verified.vue")
  },
  {
    name: "o-kryptomenach",
    path: "/o-kryptomenach",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach.vue")
  },
  {
    name: "signup-success",
    path: "/signup-success",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/signup-success.vue")
  },
  {
    name: "invite-userId",
    path: "/invite/:userId()",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/invite/[userId].vue")
  },
  {
    name: "kurzovni-listek",
    path: "/kurzovni-listek",
    component: () => import("/vercel/path0/apps/taurex/pages/kurzovni-listek.vue")
  },
  {
    name: "smena-kryptomen",
    path: "/smena-kryptomen",
    component: () => import("/vercel/path0/apps/taurex/pages/smena-kryptomen.vue")
  },
  {
    name: "styleguide-icon",
    path: "/styleguide/icon",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/icon.vue")
  },
  {
    name: "update-password",
    path: "/update-password",
    component: () => import("/vercel/path0/layers/modules/fubex-auth/pages/update-password.vue")
  },
  {
    name: "blog-post-slug",
    path: "/blog-post/:slug()",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/blog-post/[slug].vue")
  },
  {
    name: "styleguide-alert",
    path: "/styleguide/alert",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/alert.vue")
  },
  {
    name: "styleguide-badge",
    path: "/styleguide/badge",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/badge.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/index.vue")
  },
  {
    name: "styleguide-input",
    path: "/styleguide/input",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/input.vue")
  },
  {
    name: "styleguide-label",
    path: "/styleguide/label",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/label.vue")
  },
  {
    name: "styleguide-radio",
    path: "/styleguide/radio",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/radio.vue")
  },
  {
    name: "styleguide-button",
    path: "/styleguide/button",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/button.vue")
  },
  {
    name: "styleguide-dialog",
    path: "/styleguide/dialog",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/dialog.vue")
  },
  {
    name: "styleguide-select",
    path: "/styleguide/select",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/select.vue")
  },
  {
    name: "styleguide-shadows",
    path: "/styleguide/shadows",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/shadows.vue")
  },
  {
    name: "styleguide-checkbox",
    path: "/styleguide/checkbox",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/checkbox.vue")
  },
  {
    name: "smenarensky-software",
    path: "/smenarensky-software",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/smenarensky-software.vue")
  },
  {
    name: "styleguide-file-input",
    path: "/styleguide/file-input",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/file-input.vue")
  },
  {
    name: "styleguide-theme",
    path: "/styleguide/theme",
    component: () => import("/vercel/path0/layers/components/fubex-components/pages/styleguide/theme/index.vue")
  },
  {
    name: "nakup-kryptomen-na-firmu",
    path: "/nakup-kryptomen-na-firmu",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/nakup-kryptomen-na-firmu.vue")
  },
  {
    name: "o-kryptomenach-post-slug",
    path: "/o-kryptomenach-post/:slug()",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach-post/[slug].vue")
  },
  {
    name: "platba-faktur-kryptomenami",
    path: "/platba-faktur-kryptomenami",
    component: () => import("/vercel/path0/layers/modules/fubex-pages/pages/platba-faktur-kryptomenami.vue")
  },
  {
    name: "blog-page",
    path: "/blog/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/blog.vue")
  },
  {
    name: "blog-tags",
    path: "/blog/tag-:tags/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/blog.vue")
  },
  {
    name: "blog-query",
    path: "/blog/q-:q/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/blog.vue")
  },
  {
    name: "crypto-page",
    path: "/o-kryptomenach/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach.vue")
  },
  {
    name: "crypto-tags",
    path: "/o-kryptomenach/tag-:tags/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach.vue")
  },
  {
    name: "crypto-query",
    path: "/o-kryptomenach/q-:q/:page(\\d+)?",
    component: () => import("/vercel/path0/layers/modules/fubex-blog/pages/o-kryptomenach.vue")
  },
  {
    name: component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDkMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDk
  },
  {
    name: component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDkMeta?.name,
    path: "/profile/",
    component: component_45stubQ6E0rlNNePzf6zQv1Dm9cPUtPe7hTilZMMRagCLCuDk
  }
]